// Feis and grade exam late-entry window (MC2 5a45d7e3, Devin 2026-10-18).
// After the closing day an event shows as closed but keeps taking late
// entries, with the after-close late fee, through its "late entries end"
// day: the organizer's lateEntryCloseDate, else the event day itself. A late
// end on the closing day means no late entries. Same rule as the backend
// helpers/registrationOpen.js (registrationWindowState). Stored dates are UTC
// midnight of a calendar day, read with formatDate.
import { formatDate } from "./formatDate";

/** The last day late entries are taken (a stored calendar day), or null. */
export const lateEntriesEnd = (event) =>
  (event && (event.lateEntryCloseDate || event.feis_date || event.exam_date)) || null;

const endOfDay = (stored) => {
  const d = formatDate(stored);
  d.setHours(23, 59, 59, 999);
  return d;
};

/** True after the closing day, through the late entries end day. */
export const inLateWindow = (event, now = new Date()) => {
  if (!event?.closing_date) return false;
  const lateEnd = lateEntriesEnd(event);
  return now > endOfDay(event.closing_date) && !!lateEnd && now <= endOfDay(lateEnd);
};
